module.exports = __webpack_public_path__ + "img/logo-hotelv-nesplein--dark.70ccf53e5043bdc479b3487c82477b11.svg";